/**
 * The Space opened when no surface binding resolves a default for a sphere
 * (no deployed approach, or none of its bindings match the viewer/stage/intent).
 * This is a surface fallback only — it carries no authorization weight; every
 * metaspace still gates its own content behind `sphere#view` / `metaspace_template#view`.
 */
export const FALLBACK_METASPACE_SYSTEM_NAME = 'center_armillary_view';
